import { recordEvent } from 'utilities/uTagging';

export const PAYDAY_END_OF_MONTH = 'END_OF_MONTH';
export const PAYDAY_PARTICULAR_DAY = 'ANNIVERSARY';

export const triggerRecordEvent = payload => {
    recordEvent(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        ...payload,
        categoriaEvento: 'interaccion en prestamo aprobado contratacion',
    });
};
